import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import { isEmptyString, isUndefinedOrNull } from 'src/utils/general';

export default class ConvertAmountService extends AbstractApiService {
  public constructor() {
    super({});
  }

  convertValueAccordingToLocale(
    value: string,
    sourceLocale: string,
    destLocale: string,
  ): Promise<any> {
    const formData = new FormData();

    if (isUndefinedOrNull(value) || isEmptyString(value)) {
      value = '0';
    }

    formData.append('value', value);
    formData.append('dest_locale', destLocale);
    formData.append('source_locale', sourceLocale);
    return super.post(api.get_formatted_amount, formData);
  }

  convertMultiValuesAsLocale(
    values: string,
    sourceLocale: string,
    destLocale: string,
  ): Promise<any> {
    // const formData = new FormData();
    // formData.append('values', values);
    // formData.append('dest_locale', destLocale);
    // formData.append('source_locale', sourceLocale);
    const response = {
      values: values,
      dest_locale: destLocale,
      source_locale: sourceLocale,
      request_id: '',
    };

    return super.post(api.get_formatted_amounts, response);
  }
}
